module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container logged-out-content"
  }, [_c('form', {
    staticClass: "block form-md",
    attrs: {
      "autocomplete": "off",
      "name": "loginForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content text-bold text-center h4"
  }, [_vm._v("\n      Select a product:\n    ")]), _vm._v(" "), _c('context-selector'), _vm._v(" "), (_vm.error.message) ? _c('error-display', [(_vm.error.type === 'ACCOUNT_LOCKED') ? _c('div', [_vm._v("\n        Your account is locked. Please use the\n        "), _c('router-link', {
    attrs: {
      "to": "ForgotPassword"
    }
  }, [_vm._v("forgot password")]), _vm._v("\n        function to reset your account and password.\n      ")], 1) : _c('div', [_vm._v("\n        " + _vm._s(_vm.error.message) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.context) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.context === 'patient') ? _c('under-construction-display', {
    attrs: {
      "appLinks": _vm.links
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'practice') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Username",
      "validation": _vm.$v.credentials.username
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.context === 'academic') ? _c('input-text', {
    attrs: {
      "name": "username",
      "label": "Email address",
      "validation": _vm.$v.credentials.username
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.context !== 'patient') ? _c('input-password', {
    attrs: {
      "name": "password",
      "label": "Password",
      "validation": _vm.$v.credentials.password
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.context && (_vm.context !== 'patient')) ? _c('div', {
    staticClass: "footer"
  }, [_c('submit-button', {
    attrs: {
      "id": "login-submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('p', [_vm._v("Trouble signing in? "), _c('router-link', {
    attrs: {
      "to": "ForgotPassword"
    }
  }, [_vm._v("Click here")])], 1)])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/Patient-Icon.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('h2', [_vm._v("Login")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7487c2d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Login.vue
// module id = 664
// module chunks = 5